import axios from 'axios'

const server = axios.create({
    baseURL:'/api',
})

server.interceptors.request.use(
    config => {
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
server.interceptors.response.use(
    response => {
        const res = response.data
        return res
    },
    error => {
        return Promise.reject(error)
      }
)

// // 解析参数
// const formatParams =  (method = 'GET', params) => {
//     //headers配置
//     const headers = {
//         'Content-Type': 'application/json;charset=utf-8',
//     }
//     switch (method) {
//         case 'POST':
//             return {
//                 headers,
//                 method,
//                 data:params
//             }
//         case 'PUT':
//             return {
//                 headers,
//                 method,
//                 data:params
//             }
//         case 'DELETE':
//             return {
//                 headers,
//                 method,
//             }
//         case 'GET':
//             return {
//                 headers,
//                 method,
//                 params
//             }
//         default:
//             return {
//                 headers,
//                 method,
//                 params
//             }
//     }
// }
export default server


// WEBPACK FOOTER //
// ./src/utils/request.js